import createIcon from '../../createIcon';

/**
 * @component @name SwipeDownAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgMTIuOUMxNS4yOCAxMi40NCAxNyAxMC40MiAxNyA4QzE3IDUuMjQgMTQuNzYgMyAxMiAzQzkuMjQgMyA3IDUuMjQgNyA4QzcgMTAuNDIgOC43MiAxMi40NCAxMSAxMi45VjE3LjE3TDkuNDEgMTUuNThMOCAxN0wxMiAyMUwxNiAxN0wxNC41OSAxNS41OUwxMyAxNy4xN1YxMi45WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwipeDownAlt = createIcon('SwipeDownAlt', [
  [
    'path',
    {
      d: 'M13 12.9C15.28 12.44 17 10.42 17 8C17 5.24 14.76 3 12 3C9.24 3 7 5.24 7 8C7 10.42 8.72 12.44 11 12.9V17.17L9.41 15.58L8 17L12 21L16 17L14.59 15.59L13 17.17V12.9Z',
      key: '19mdod',
    },
  ],
]);

export default SwipeDownAlt;
